export default __webpack_public_path__ + "static/media/Group 6493.78b0f1f1.svg";